import { HOST_TYPE } from '@utils/api-helper/host';
import fetch from '@utils/api-helper/fetch';

export const getHomepageEndpoint = (goalUID, isRecordedGoal) =>
  `v1/syllabus/${
    isRecordedGoal ? 'recorded_content_home/recorded_feed' : 'home/feed'
  }/?goal_uid=${goalUID}`;

export const getTopicInfoEndpoint = (goalUID, topicUID, educatorUID) =>
  `v1/syllabus/concept/feed/?goal_uid=${goalUID}&topic_uid=${topicUID}${
    educatorUID ? `&educator_uid=${educatorUID}` : ''
  }`;

export const getClassInfoEndpoint = (uid, goalUID, isSyllabusFeed = false) =>
  `v1/uplus/classes/${uid}/info_v2/?${
    isSyllabusFeed ? 'feed=syllabus_feed&' : ''
  }goal_uid=${goalUID}`;

export const getClassDetailsEndpoint = (classUID) =>
  `v1/uplus/classes/${classUID}/details/`;

const options = {
  useAuthToken: true,
  useSearchToken: false,
  isFormData: false,
  hostType: HOST_TYPE.DEFAULT,
  useCamelCase: true
};

export const apiFetcher = (url, fetcherOptions) =>
  fetch(url, { ...options, ...fetcherOptions });
